/** The awareness `viewId` for a document's body surface. */
export const BODY_VIEW_ID = 'body';

/**
 * The awareness `viewId` for a surface, given its fragment name — `null` for the
 * body surface, which is not a manifest entry.
 *
 * Mirrors the shape multi-surface entities established (a derived-tabs
 * manifest keyed by fragment name): a reserved key for the built-in surface
 * and a `frag:`-prefixed key for manifest entries, so a fragment literally
 * named `body` cannot collide with the body surface.
 *
 * Publisher and filterer must both call this. Presence filtering is fail-closed
 * (`filter-presence-by-view.ts`), so two places computing the key differently
 * would make peers silently vanish from avatar lists rather than error.
 */
export function surfaceViewId(fragment: string | null): string {
  return fragment === null ? BODY_VIEW_ID : `frag:${fragment}`;
}
